module.exports = __webpack_public_path__ + "static/media/NarroginObserver-devicecomp-min.7aa48842.webp";